import Api from 'src/api/Base'

class PostChangeControl extends Api {
  requestUrl = `/api/ChangeControl`

  method = 'POST'
}

export default PostChangeControl
